import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FlytProcessStrip, FlytClientsGrid } from '../pages/FlytProcessPage';

/**
 * Compact, scroll-friendly teaser of FLYT Studios for the homepage middle.
 * Shows: process strip + client roster grid + a "see more" CTA.
 */
const FlytStudiosTeaser = () => (
  <section className="relative py-20 lg:py-28 bg-[#0a0a0a] text-white overflow-hidden" data-testid="flyt-studios-teaser">
    <div
      className="absolute inset-0 opacity-25 pointer-events-none"
      style={{
        backgroundImage:
          'radial-gradient(circle at 12% 20%, rgba(212,175,55,0.35), transparent 55%), radial-gradient(circle at 88% 80%, rgba(240,216,117,0.25), transparent 55%)'
      }}
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Section header */}
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <div className="max-w-2xl">
          <p className="font-italic text-yellow-300 text-sm mb-3 tracking-wider uppercase">FLYT Studios</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95]">
            We build the <span className="gold-gradient">stories</span><br />creators want told.
          </h2>
        </div>
        <Link
          to="/flyt/process"
          className="btn-pill bg-white text-black inline-flex items-center gap-2 font-bold flex-shrink-0"
          data-testid="see-studios-cta"
        >
          See the Studios <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      {/* Process strip */}
      <div className="mb-16">
        <FlytProcessStrip compact />
      </div>

      {/* Client roster */}
      <FlytClientsGrid limit={7} showHeading={false} />

      <div className="mt-12 text-center">
        <Link to="/flyt/process" className="font-body font-bold text-sm text-yellow-300 hover:text-white inline-flex items-center gap-1">
          See full case studies, BTS &amp; process for each client <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default FlytStudiosTeaser;
